export default "/_next/static/chunks/fonts/Montserrat-ThinItalic-latin-ca4b479907b48e995ac89293babe6e6f.woff2";